// export const navMenus = [
//   {
//     lable: "בית",
//     to: "/",
//   },
//   {
//     lable: "קצת עלי",
//     to: "/about",
//   },
//   {
// lable: "מיומנויות",
//     to: "/skills",
//   },
//   {
//     lable: "קורות חיים",
//     to: "/resume",
//   },
//   {
//     lable: "תיק עבודות",
//     to: "/portfolio",
//   },
//   {
//     lable: "צור קשר",
//     to: "/contact",
//   },
// ];

export const navMenus = [
  {
    label: "בית",
    to: "/",
  },
  {
    label: "קצת עלי",
    to: "/about",
  },
  {
    label: "מיומנויות",
    to: "/skills",
  },
  {
    label: "קורות חיים",
    to: "/resume",
  },
  {
    label: "תיק עבודות",
    to: "/portfolio",
  },
  {
    label: "צור קשר",
    to: "/contact",
  },
];
